import { useEffect } from 'react';
import Checkbox from '@/Components/Checkbox';
import GuestLayout from '@/Layouts/GuestLayout';
import InputError from '@/Components/InputError';
import InputLabel from '@/Components/InputLabel';
import PrimaryButton from '@/Components/PrimaryButton';
import TextInput from '@/Components/TextInput';
import { Head, Link, useForm } from '@inertiajs/react';
import ShadcnExample from '@/Components/ShadcnExample';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { AtSignIcon } from 'lucide-react';
import PasswordField from '@/Components/comp-23';

export default function Login({ status, canResetPassword }) {
   const { data, setData, post, processing, errors, reset,  } = useForm({
      email: '',
      password: '',
      remember: '',
   });

   useEffect(() => {
      return () => {
         reset('password');
      };
   }, []);

   const handleOnChange = (event) => {
      setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
   };

   const submit = (e) => {
      e.preventDefault();

      post(route('login'));
   };

   return (
      <GuestLayout>
         <Head title="Log in" />
         <div className="text-center mb-8">
            <h3 className="text-gray-600 text-lg">Welcome Back!</h3>
            <p className="text-gray-600">
               Sign in and starting earning exciting rewards.
            </p>
         </div>

         {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

         <form onSubmit={submit}>
            <div>
               {/* <InputLabel htmlFor="email" value="Username" /> */}
               <div className="*:not-first:mt-2">
                  <div className="relative">
                     <Input id={'email'} value={data.email} aria-invalid={Boolean(errors.email)} name="email" className="peer ps-9" isFocused autoFocus placeholder="Username" type="text" onChange={handleOnChange} />
                     <div
                        className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50">
                        <AtSignIcon size={16} aria-hidden="true" />
                     </div>
                  </div>
               </div>

               <InputError message={errors.email} className="mt-2" />
            </div>

            <div className="mt-4">
               <PasswordField value={data.password} aria-invalid={Boolean(errors.password)} name={'password'} id={'password'} onChange={handleOnChange} />
               <InputError message={errors.password} className="mt-2" />
            </div>

            <div className="flex items-center justify-between mt-4 mb-10">
               <label className="flex items-center">
                  <Checkbox name="remember" value={data.remember} onChange={handleOnChange} />
                  <span className="ml-2 text-sm text-gray-600">Remember me</span>
               </label>
               {canResetPassword && (
                  <Link
                     href={route('password.request')}
                     className="underline text-sm text-gray-600 hover:text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                     Forgot your password?
                  </Link>
               )}
            </div>

            <div className="mt-4">
               <Button variant="default" className="w-full" isPending={processing} disabled={processing}>Sign In</Button>
            </div>
            <div className='mt-4 text-sm text-center text-muted-foreground'>
               Don't have Account? <Link className='text-primary' href="/register">Create account</Link>
            </div>
         </form>
      </GuestLayout>
   );
}
